/**
 * Performs a case-insensitive conversion of 'true' or 'false' strings to their boolean equivalents.
 * Any other values cause an error to be thrown.
 * @param str A string containing 'true' or 'false'. Casing is irrelevant.
 * @returns A boolean.
 */
export const stringToBoolean = (str: string): boolean => {
    if (str.toLowerCase() === 'true') {
        return true;
    } else if (str.toLowerCase() === 'false') {
        return false;
    } else {
        throw new Error('Invalid boolean string.');
    }
};
